// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Footer from './components/Footer';
import Omra2025 from './pages/Omra2025'; // Importez la nouvelle page
import Hajj2025 from './pages/Hajj2025'; 
import Blog from './pages/Blog';
import Contact from './pages/Contact'; 
import ReservationPage from './components/ReservationPage'; // Importez le nouveau composant ReservationPage
import { LanguageProvider } from './LanguageContext';
import Article from './components/Article'; // ou le chemin correct vers votre composant


function App() {
  return (
    <LanguageProvider>
    <Router>
      <div className="bg-gray-50 font-sans">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/omra" element={<Omra2025 />} />
          <Route path="/hajj" element={<Hajj2025 />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/reservation/:offerTitle" element={<ReservationPage />} /> {/* Route pour la page de réservation */}
          <Route path="/blog/:articleId" element={<Article />} />

          {/* Ajoutez d'autres routes ici si nécessaire */}
        </Routes>
        <Footer />
      </div>
    </Router>
    </LanguageProvider>
  );
}

export default App;